export type HelperMessage = {
  id: string;
  displayName: string;
  tag?: string;
  body: string;
};

/** In-memory global FIFO ring (rotate-to-back). Replaced by API in Task 12. */
export class FakeFifo {
  private q: HelperMessage[];

  constructor(seed: HelperMessage[]) {
    this.q = [...seed];
  }

  get length(): number {
    return this.q.length;
  }

  /** Take front n, rotate each to back */
  next(n: number): HelperMessage[] {
    if (this.q.length === 0) return [];
    const out: HelperMessage[] = [];
    const take = Math.min(n, this.q.length);
    for (let i = 0; i < take; i++) {
      const m = this.q.shift()!;
      out.push(m);
      this.q.push(m);
    }
    return out;
  }

  push(m: HelperMessage): void {
    this.q.push(m);
  }
}

export const FOUNDING_SEEDS: HelperMessage[] = [
  {
    id: "seed-1",
    displayName: "Archive",
    tag: "00",
    body: "Everything that lives is designed to end. Keep flying anyway.",
  },
  {
    id: "seed-2",
    displayName: "Visitor",
    tag: "A1",
    body: "Your existence is not a mistake. One more lane. One more breath.",
  },
  {
    id: "seed-3",
    displayName: "Choir",
    tag: "E",
    body: "We left these words in the dark so you would not be alone here.",
  },
  {
    id: "seed-4",
    displayName: "Relay",
    body: "Refuse if you must. Accept if you need. Either path is yours.",
  },
  {
    id: "seed-5",
    displayName: "Museum",
    tag: "01",
    body: "This is only a tribute. The courage is still real. Clear the sky.",
  },
];
